<template>
  <div class="content">
    <div class="container-fluid" v-if="!data">
      <div style="border:2pt lightgray solid; width:100%; height:300px;">Chargement en cours ...</div>
    </div>



    <div class="container-fluid" v-if="data">

      <b-navbar type="light" variant="light" sticky>
        <b-navbar-nav>
          <b-button pill variant="secondary" :to="urlBack()" v-if="hasBack()"><b-icon icon="caret-left" aria-hidden="true"></b-icon>Retour</b-button>
          <!-- https://bootstrap-vue.org/docs/components/navbar -->
          
          
          <b-nav-item href="#"v-if="data.companyParent" :to="urlWithRedirect('/admin/company/'+data.companyParent.id)">{{ data.companyParent.name }} ➡</b-nav-item>
          <b-navbar-brand tag="h1" class="mb-0"><status-icon :status="data.company._status" /> {{ data.company.name }}</b-navbar-brand> 

          <!-- Navbar dropdowns -->
          <b-nav-item-dropdown text="Actions" left v-if="isAdmin()">
            <b-dropdown-item :to="urlWithRedirect('/ppe_eu/company_eu/'+data.company.id)"> Modifier</b-dropdown-item>
            <b-dropdown-item v-if="data.parent" @click="doCompanyDetachFromParent()"> Détacher de son entité parente</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav> 
      </b-navbar>
              


      <!-- https://bootstrap-vue.org/docs/components/tabs -->
      <b-card no-body >
        <b-tabs content-class="mt-3" card>
          <!-- OPERATIONS -->
          <b-tab active v-if="data.company.isHost"><template #title><i class="nc-icon nc-attach-87"></i> Opérations de l'entité ({{ data.operations.length }})</template>
            
            <p v-if="data.operations.length===0"><label>Aucune opération déclarée pour cette entité</label></p>
            

            <!-- Autocomplete component https://github.com/iliyaZelenko/vue-cool-select
            https://iliyazelenko.github.io/vue-cool-select/#/
            -->
            <div>Attacher une opération existante: </div>
            <div class="d-flex align-items-center">
              <div class="col-8">
                <cool-select
                      
                      v-model="operationSelected"
                      :items="operationList"
                      :loading="operationIsLoading"
                      item-text="label"
                      placeholder="Choisissez une opération existante"
                      disable-filtering-by-search
                      @search="onOperationChanged"
                      name="findOperation"
                    >
                  <template #no-data>
                    {{ noData ? "Aucun résultat." : "Tapez au moins 2 lettres." }}
                  </template>
                  <template #item="{ item }">
                    <div class="d-flex">
                      <span class="col-2 p-1"> {{ item.code }} </span>
                      <span class="col-6 p-1"> {{ item.operationname }} </span>
                      <span class="col-4 p-1"> {{ item.companyname }} </span>
                      <!-- <img class="logo m1-auto p-2"  :src="item.img" v-if="item.img" style="max-width: 30pt;"  /> -->
                    </div>
                  </template>
                  <template v-if="operationIsLoading" #input-end>
                    <img src="https://i.imgur.com/mTNe6tr.gif" class="loading-indicator">
                  </template>
                </cool-select> 
                <label>Cette action va détacher l'opération de son entité pour la rattacher à {{data.company.name}}</label>
               </div>
              <button class="btn btn-secondary" :disabled="!operationSelected" @click="doOperationAttach">Attacher cette opération</button>
            </div>      
            <b-table striped hover 
              responsive
              v-if="data.operations.length>0"
              :fields="[
                {key:'code',          label:'Code'},
                {key:'operationname', label:'Nom'},
                {key:'sitename',      label:'Site'}, 
                {key:'city',          label:'Ville'},
                ]"
              :items="data.operations" >
              <template #cell(code)="row">
                <router-link :to="urlWithRedirect('/ppe_eu/operation_home/'+row.item.id)">{{row.item.code}}</router-link>
              </template>
            </b-table>

            <router-link :to="urlWithRedirect('/ppe_eu/operation/'+data.company.owner+'?selectedeu='+data.company.id)">
              <button class="btn btn-default">Décrire une nouvelle opération</button>
            </router-link>

          </b-tab>

          <!-- ACCOUNTS -->
          <b-tab><template #title><i class="nc-icon nc-single-02"></i> Comptes autorisés ({{ data.accounts.length }})</template>

            <p v-if="data.accounts.length===0"><label>Aucun compte pour cette entité</label></p>

            <!-- Autocomplete component https://github.com/iliyaZelenko/vue-cool-select
            https://iliyazelenko.github.io/vue-cool-select/#/
            -->
            <div>Attacher un compte : </div>
            <div class="d-flex align-items-center">
              <div class="col-8">
                <cool-select
                      
                      v-model="accountSelected"
                      :items="accountList"
                      :loading="accountIsLoading"
                      item-text="label"
                      placeholder="Choisissez un compte existant"
                      disable-filtering-by-search
                      @search="onAccountChanged"
                      name="findAccount"
                    >
                  <template #no-data>
                    {{ noData ? "Aucun résultat." : "Tapez au moins 2 lettres." }}
                  </template>
                  <template #item="{ item }">
                    <div class="d-flex">
                      <span class="col-4 p-1"> {{ item.name }} </span>
                      <span class="col-4 p-1"> {{ item.email }} </span>
                      <span class="col-4 p-1"> {{ item.companyname }} </span>
                    </div>
                  </template>
                  <template v-if="accountIsLoading" #input-end>
                    <img src="https://i.imgur.com/mTNe6tr.gif" class="loading-indicator">
                  </template>
                </cool-select> 
                <label>Cette action va autoriser ce compte à voir l'entité {{data.company.name}}</label>
               </div>
              <button class="btn btn-secondary" :disabled="!accountSelected" @click="doAccountAttach">Ajouter ce compte</button>
            </div>      
            <b-table striped hover 
              responsive
              v-if="data.accounts.length>0"
              :fields="[
                {key:'name',          label:'Nom'},
                {key:'email',         label:'Email'},
                {key:'companyName',   label:'Société'}, 
                {key:'groups',        label:'Autorisations'}, 
                {key:'#',             label:'Action'}, 
                ]"
              :items="data.accounts" >
              
              <template #cell(groups)="row">
                {{ toGroupLabels(row.item.groups) }}  
              </template>
              <template #cell(#)="row">
                <button class="btn btn-danger" @click="doAccountDetach(row.item)">retirer</button>
              </template>
              <template #cell(companyName)="row">
                {{row.item.company.name}}
              </template>
              <template #cell(name)="row">
                <router-link v-if="!row.item.company.isHost" :to="urlWithRedirect('/ppe_ee/home/'+row.item.id)">{{row.item.name}}</router-link>
                <router-link v-if="row.item.company.isHost"  :to="urlWithRedirect('/ppe_eu/home/'+row.item.id)">{{row.item.name}}</router-link>
              </template>
            </b-table>
                  
          </b-tab>

          <!-- SUB COMPANIES -->
          <b-tab v-if="data.company.isHost"><template #title><i class="nc-icon nc-bank"></i> Sous-entités ({{ data.descendantCompanies.length }})</template>
            <label v-if="data.descendantCompanies.length===0">Aucune entité attachée</label>
            



            <!-- Autocomplete component https://github.com/iliyaZelenko/vue-cool-select
            https://iliyazelenko.github.io/vue-cool-select/#/
            -->
            <div>Attacher une sous-entité : </div>
            <div class="d-flex align-items-center">
              <div class="col-8">
                <cool-select
                      
                      v-model="companySelected"
                      :items="companyList"
                      :loading="companyIsLoading"
                      item-text="label"
                      placeholder="Choisissez parmis les entités existantes"
                      disable-filtering-by-search
                      @search="onCompanyChanged"
                      name="findCompany"
                    >
                  <template #no-data>
                    {{ noData ? "Aucun résultat." : "Tapez au moins 2 lettres." }}
                  </template>
                  <template #item="{ item }">
                    <div class="d-flex">
                      <span class="col-5 p-1"> {{ item.name }} </span>
                      <span class="col-5 p-1"> {{ item.zip }} {{ item.city }} </span>
                    </div>
                  </template>
                  <template v-if="companyIsLoading" #input-end>
                    <img src="https://i.imgur.com/mTNe6tr.gif" class="loading-indicator">
                  </template>
                </cool-select> 
                <label>Cette action va ajouter cette entité sous {{data.company.name}}</label>
               </div>
              <button class="btn btn-secondary" :disabled="!companySelected" @click="doCompanyAttach">Ajouter cette entité</button>
            </div>      
            <b-table striped hover responsive
              data-cache="false"
              v-if="data.descendantCompanies.length>0"
              :fields="[
                {key:'name',    label:'Nom'},
                {key:'address', label:'Adresse'},
                {key:'zip',     label:'Code postal'}, 
                {key:'city',    label:'Ville'},
                {key:'#',       label:'Action'},
                ]"
              :items="data.descendantCompanies" >
              <template #cell(name)="row">
                <router-link :to="urlWithRedirect('/admin/company/'+row.item.id)">{{row.item.name}}</router-link>
              </template>
              <template #cell(#)="row">
                <button class="btn btn-danger" @click="doCompanyDetach(row.item)">retirer</button>
              </template>
            </b-table>

              

          </b-tab>


        </b-tabs>

      </b-card>
      



    </div>
  </div>
</template>

<style>
.table > tbody > tr > td:last-child {
  width: auto;
}

</style>

<script>

const Business = require('ppe-business')

import common from '../common/pages.js'

import { CoolSelect } from 'vue-cool-select'
import StatusIcon from '../../components/StatusIcon.vue'

// paste the line below only if you need "bootstrap" theme
import 'vue-cool-select/dist/themes/bootstrap.css'
// paste the line below only if you need "material-design" theme
//import 'vue-cool-select/dist/themes/material-design.css'
// you can also import your theme


export default {
  components: {
    CoolSelect,
    StatusIcon
  },

  data() {
    return { 
      data : undefined,

      operationList: [''],
      operationSelected : undefined,
      operationIsLoading : false,

      accountList: [''],
      accountSelected : undefined,
      accountIsLoading : false,

      companyList: [''],
      companySelected : undefined,
      companyIsLoading : false,
    }
  },

  mounted() {
    this.$http.get('/admin/company?companyid='+this.$route.params.companyid)
        .then(response => {
          console.log("/admin/company", response.data)
          this.data = response.data
        })
        .catch( (err, res) => {
          // Clone the error to read the status property (otherwise it can only be read once !!!!)
          let error = JSON.parse( JSON.stringify(err) )
					
					swal("Erreur", JSON.stringify(err.response ? err.response.data : error.message), "error");
        })
    },

  methods: {
    ...common.methods,

    toDate(apiDate) { return Business.toDate(apiDate) },
  
    toGroupLabels(groups) {
      let res = []
      for(let group of groups) {
        res.push(Business.getGroupLabel(group))
      }
      return res.join(", ")
    },

    onOperationChanged(text) {
      this.$http.get('/admin/searchoperations?q='+text)
              .then(response => {
                console.log("onOperationChanged", response.data)
                if(response.data.result.length>0)
                  this.operationList = response.data.result
              })
    },
    doOperationAttach() {
      this.$http.post('/admin/attachoperation', {operationid: this.operationSelected.id, companyid:this.$route.params.companyid })
              .then(response => {
                console.log("doOperationAttach", response.data)
                this.data.operations = response.data.operations
                this.operationSelected = null
              })
              .catch((err, res) => {
                // Clone the error to read the status property (otherwise it can only be read once !!!!)
                let error = JSON.parse( JSON.stringify(err) )
                
                swal("Erreur", JSON.stringify(err.response ? err.response.data : error.message), "error");
              })
    },

    onAccountChanged(text) {
      this.$http.get('/admin/searchaccounts?q='+text)
              .then(response => {
                console.log("onAccountChanged", response.data)
                if(response.data.result.length>0)
                  this.accountList = response.data.result
              })
    },

    doAccountAttach() {
      this.$http.post('/admin/attachaccount', {accountid: this.accountSelected.id, companyid:this.$route.params.companyid })
              .then(response => {
                console.log("doAccountAttach", response.data)
                this.data.accounts = response.data.accounts
                this.accountSelected = null
              })
              .catch((err, res) => {
                // Clone the error to read the status property (otherwise it can only be read once !!!!)
                let error = JSON.parse( JSON.stringify(err) )
                
                swal("Erreur", JSON.stringify(err.response ? err.response.data : error.message), "error");
              })
    },
    
    doAccountDetach(account) {
      this.$http.post('/admin/detachaccount', {accountid: account.id, companyid:this.$route.params.companyid })
              .then(response => {
                console.log("doAccountDetach", response.data)
                this.data.accounts = response.data.accounts
              })
              .catch((err, res) => {
                // Clone the error to read the status property (otherwise it can only be read once !!!!)
                let error = JSON.parse( JSON.stringify(err) )
                
                swal("Erreur", JSON.stringify(err.response ? err.response.data : error.message), "error");
              })
    },

    onCompanyChanged(text) {
      this.$http.get('/admin/searchcompanies?q='+text)
              .then(response => {
                console.log("onCompanyChanged", response.data)
                if(response.data.result.length>0)
                  this.companyList = response.data.result
              })
    },

    doCompanyAttach() {
      this.$http.post('/admin/attachcompany', {attachcompanyid: this.companySelected.id, companyid:this.$route.params.companyid })
              .then(response => {
                console.log("doCompanyAttach", response.data)
                this.data.descendantCompanies = response.data.descendantCompanies
                this.companySelected = null
              })
              .catch((err, res) => {
                // Clone the error to read the status property (otherwise it can only be read once !!!!)
                let error = JSON.parse( JSON.stringify(err) )
                
                swal("Erreur", JSON.stringify(err.response ? err.response.data : error.message), "error");
              })
    },
    
    doCompanyDetach(companySelected) {
      this.$http.post('/admin/detachcompany', {attachcompanyid: companySelected.id, companyid:this.$route.params.companyid })
              .then(response => {
                console.log("doCompanyDetach", response.data)
                this.data.descendantCompanies = response.data.descendantCompanies
              })
              .catch((err, res) => {
                // Clone the error to read the status property (otherwise it can only be read once !!!!)
                let error = JSON.parse( JSON.stringify(err) )
                
                swal("Erreur", JSON.stringify(err.response ? err.response.data : error.message), "error");
              })
    },

    doCompanyDetachFromParent() {
      console.log("doCompanyDetachFromParent")
      this.$http.post('/admin/removecompanyparent', {companyid:this.$route.params.companyid })
              .then(response => {
                console.log("doCompanyDetachFromParent", response.data)
                //this.data.descendantCompanies = response.data.descendantCompanies
                this.data = response.data
              })
              .catch((err, res) => {
                // Clone the error to read the status property (otherwise it can only be read once !!!!)
                let error = JSON.parse( JSON.stringify(err) )
                
                swal("Erreur", JSON.stringify(err.response ? err.response.data : error.message), "error");
              })
    },

  }

}
</script>